import { SvgNoteImageProps } from "..";

export default function reNote({style}: SvgNoteImageProps) {
    return <svg
		style={style}
		className={'svg-note'}
        viewBox="0 0 311.9 311.9"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            style={{
                strokeWidth: 6,
            }}
            d="m 226.7,202.2 h -37.58 c 16.84847,-9.59024 27.369,-27.3755 27.66,-46.76 0,-30.82 -27.24,-55.81 -60.83,-55.81 -33.59,0 -60.83,25 -60.83,55.81 0.290998,19.3845 10.81153,37.16976 27.66,46.76 l -37.720165,0.0972 c -4.162017,-0.20555 -6.686251,2.56369 -6.702754,4.46517 0.03294,3.70275 3.140296,5.53203 6.842919,5.4876 l 141.786,0.0243 c 3.91733,-0.27504 6.4675,-2.65252 6.484,-4.55241 -0.0196,-2.84891 -3.0702,-5.54969 -6.77,-5.5219 z M 113.37,120.28 c 13.67,-16.56 43.81,-14.23 67.34,5.19 23.53,19.42 31.49,48.59 17.82,65.14 -13.67,16.55 -43.82,14.23 -67.34,-5.2 -23.52,-19.43 -31.5,-48.58 -17.82,-65.13 z" />
    </svg>
}